import { render, staticRenderFns } from "./SuggestTextInput.vue?vue&type=template&id=0e57a902&scoped=true"
import script from "./SuggestTextInput.vue?vue&type=script&lang=js"
export * from "./SuggestTextInput.vue?vue&type=script&lang=js"
import style0 from "./SuggestTextInput.vue?vue&type=style&index=0&id=0e57a902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e57a902",
  null
  
)

export default component.exports